import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors/pathBuilder';
import StepNumber from './StepNumber';
import ContentTitle from './ContentTitle';
import ContentPerformanceFigures from './ContentPerformanceFigures';

export const LessonBody = ({
  title,
  urls,
  stepNumber,
  pathContentId,
  type,
  pathId,
}) => (
  <div className="PerformanceContent d-f jc-sb">
    <StepNumber step={stepNumber} />
    <ContentTitle {...{ title, urls, type, pathId }} />
    <ContentPerformanceFigures for={pathContentId} />
  </div>
);

const mapStateToProps = () => {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathBuilder, props),
  });
};

export default connect(mapStateToProps)(LessonBody);
